import { ConversationDetailSurface } from './ConversationDetailSurface';
import type { TeamConversationDetailData } from '../../hooks/useTeamConversationDetail';
import type { DetailBack } from '../../hooks/useDetailBack';

interface TeamConversationDetailSurfaceProps {
  data: TeamConversationDetailData;
  onNav: (id: string) => void;
  back?: DetailBack;
}

export function TeamConversationDetailSurface({ data, onNav, back }: TeamConversationDetailSurfaceProps) {
  return <ConversationDetailSurface data={data} onNav={onNav} mode="team" back={back} />;
}
